const AnalyticsIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 18.9297 20.79"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.94,1.88v-1.27c0,-0.34 -0.27,-0.61 -0.61,-0.61h-5.72c-0.34,0 -0.61,0.27 -0.61,0.61v1.27z"
        fill="#1A8B5A"
      />
      <path
        d="M16.5498,14.79v1.25h-14.1699v-1.25zM17.6797,13.66v-10.02c-0.0002,-0.626 -0.5069,-1.13 -1.1299,-1.13h-3.0176l0.0098,-0.01h-11.1621c-0.6161,0 -1.1297,0.507 -1.1299,1.14v10.02c0.0001,0.626 0.5069,1.13 1.1299,1.13v1.25l-0.2422,-0.013c-1.1173,-0.113 -2.0108,-0.999 -2.125,-2.123l-0.0127,-0.244v-10.02c0.0002,-1.32 1.0701,-2.39 2.3799,-2.39h14.1797l-0.0098,0.01c1.3099,0 2.3797,1.06 2.3799,2.38v10.02l-0.0117,0.242c-0.1212,1.197 -1.1306,2.138 -2.3682,2.138v-1.25c0.6262,0 1.1298,-0.507 1.1299,-1.13z"
        fill="currentColor"
      />
      <path
        d="M4.7441,15.74l-1.3398,5.05l-1.209,-0.32l1.3408,-5.05z"
        fill="currentColor"
      />
      <path
        d="M16.7441,20.47l-1.208,0.32l-1.3408,-5.05l1.209,-0.32z"
        fill="currentColor"
      />
      <path
        d="M13.9351,5.527c0.2725,-0.312 0.7466,-0.344 1.0586,-0.071c0.3115,0.272 0.3434,0.746 0.0712,1.057l-4.0458,4.63l-4.0479,-1.943l-1.8232,1.882c-0.2883,0.297 -0.7622,0.305 -1.0596,0.016c-0.2975,-0.288 -0.3049,-0.763 -0.0166,-1.06l2.5752,-2.657l3.9931,1.916z"
        fill="#1A8B5A"
      />
    </svg>
  );
};

export default AnalyticsIcon;
